import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, theme, Dropdown } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';
import MultiPriceModal from '../modals/multiPrice';
import SerialModal from '../modals/serial';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';



const Product = (props) => {

    const { api, userData, settingData, salableData, customerPriceData, openAddProductModal, rateFromToCurrency } = useContext(DataContext);
    const { tabData, setCart } = useContext(PosCartContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { refItems, selectedTab, title, selectedCategory, selectedCurrency, journalVoucher, idRow, selectedPriceType } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [showProducts, setShowProducts] = useState([]);

    const [showMultiPriceModal, setShowMultiPriceModal] = useState(false);
    const [showSerialModal, setShowSerialModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [serial, setSerial] = useState("");
    const [searchInput, setSearchInput] = useState("");


    const cart = tabData[selectedTab].cart;

    const multiPriceModal = () => {
        setShowMultiPriceModal(!showMultiPriceModal)
    }

    const serialModal = () => {
        setShowSerialModal(!showSerialModal)
    }

    // Add this helper function at the top of your component
    const sortProducts = (products) => {
    console.log('Before sorting:', products.map(p => ({ id: p.id, dragId: p.dragId, name: p.name })));
    
    const sorted = [...products].sort((a, b) => {
        if (a.dragId !== null && b.dragId !== null) {
        return a.dragId - b.dragId;
        }
        else if (a.dragId !== null) {
        return -1;
        }
        else if (b.dragId !== null) {
        return 1;
        }
        else {
        return a.id - b.id;
        }
    });
    
    console.log('After sorting:', sorted.map(p => ({ id: p.id, dragId: p.dragId, name: p.name })));
    return sorted;
    };

    // set products by category
    useEffect(() => {
    if (selectedCategory) {
        const productData = salableData.filter((product) => product.categoryId === selectedCategory);
        setShowProducts(sortProducts(productData));
    }
    }, [selectedCategory, salableData]);


    const addCompoundsToCart = (product) => {
        const productCompounds = product.productCompounds;
        let updatedProductCompounds = [];
        for (const compound of productCompounds) {
            const getProduct = salableData.find(product => product.id === compound.productId);
            const addProduct = {
                compoundId: compound.compoundId,
                productId: getProduct.id, 
                quantity: compound.quantity,
                type: getProduct.type,
                isStock: getProduct.isStock,
            }

            updatedProductCompounds.push(addProduct);

        }
        product.productCompounds = updatedProductCompounds;
        return product;
    }


    const addProduct = (product, quantity) => {

        const vat = product?.vatGroup?.vat;

        let accountId;
        if (product.type == 'simple' || product.type == 'serialized') {
            accountId = settingData.salesOfGoodsAccountId;
        }
        else if (product.type == 'service') {
            accountId = settingData.salesOfServiceAccountId;
        }
        else if (product.type == 'compound') {
            accountId = settingData.salesOfGoodsAccountId;
            product = addCompoundsToCart(product);
        }
        else if (product.type == 'rawMaterial') {
            accountId = settingData.salesOfRawMaterialAccountId;
        }
        else if (product.type == 'production') {
            accountId = settingData.salesOfFinishedProductsAccountId;
        }

        const getCost = rateFromToCurrency(product.currency, selectedCurrency, product.cost);
        const getPrice = rateFromToCurrency(product.currency, selectedCurrency, product.price);

        const productAdd = {
            accountId: accountId,
            productId: product.id,
            name: product.name,
            barcode: product.barcode,
            netQuantity: quantity,
            type: product.type,
            unit: product.unit,
            unitName: product.unit,
            unitQuantity: 1,
            units: product.units,
            currency: product.currency,
            productCompounds: product.productCompounds || [],

            cost: getCost,
            netCost: getCost,
            totalCost: getCost * quantity,

            isStock: product.isStock,

            prices: product.prices,
            itemPrice: getPrice,
            price: getPrice,
            priceDiscountPercentage: 0,
            priceDiscountAmount: 0,
            totalPrice: getPrice * quantity,
            netPrice: getPrice,
            details: '',

            vatPercentage: vat,
            vatAmount: parseFloat(product.price * vat / 100),

        }

        setSelectedProduct(productAdd);

        if (product.type == 'serialized') {
            serialModal();
        } else {
            addProductToCart(productAdd, quantity)
        }
    };


    const addProductToCart = (productAdd, quantity) => {

        const productExists = cart.some((item) => (item.productId === productAdd.productId) && (item.unitQuantity == 1));
        let updatedCart = [...cart];

        // If Product exists then add quantity
        if (productExists && productAdd.type !== 'serialized') {
            updatedCart = cart.map((item) => {
                if (item.productId === productAdd.productId && item.unitQuantity == 1) {
                    const newQuantity = parseFloat(item.netQuantity) + parseFloat(quantity);
                    return {
                        ...item,
                        netQuantity: newQuantity,
                        totalPrice: newQuantity * item.netPrice,
                        totalCost: item.netCost * newQuantity,
                    };
                }
                return item;
            });
        } else {

            // First condtion use customer Price
            let customerPriceExists = false;
            if (journalVoucher?.accountId && settingData?.useCustomerPrice) {
                const filteredPrices = customerPriceData.filter(product => product?.accountId == journalVoucher?.accountId);
                customerPriceExists = filteredPrices.find(product => product.productId == productAdd.productId);
            }

            //if use customer price
            if (customerPriceExists) {
                const price = rateFromToCurrency(customerPriceExists.currency, selectedCurrency, customerPriceExists.price);
                productAdd.itemPrice = price;
                productAdd.price = price;
                productAdd.netPrice = price;
                productAdd.totalPrice = price;
                updatedCart.push(productAdd);
            } else {



                const selectedPriceValue = productAdd?.prices?.find(p => p.name === selectedPriceType)?.price;
                if (selectedPriceValue) {
                    productAdd.itemPrice = selectedPriceValue;
                    productAdd.price = selectedPriceValue;
                    productAdd.netPrice = selectedPriceValue;
                    productAdd.totalPrice = selectedPriceValue;
                    updatedCart.push(productAdd);
                }
                else {
                    if (productAdd?.prices?.length > 0) {
                        setShowMultiPriceModal(true);
                    }
                    // Second condtion use normal Price
                    else {
                        updatedCart.push(productAdd);
                    }
                }

            }
        }

        setCart(updatedCart, selectedTab);
    };

    



    useEffect(() => {
        if (searchInput) {
            const delayDebounceFn = setTimeout(() => {
            if (searchInput.trim()) {
                const search = searchInput.toLowerCase();
                const matchingProducts = salableData.filter(product => 
                product?.name?.toLowerCase().includes(search)
                );
                setShowProducts(sortProducts(matchingProducts));
            } else {
                if (selectedCategory) {
                const productData = salableData.filter((product) => product.categoryId === selectedCategory);
                setShowProducts(sortProducts(productData));
                } else {
                setShowProducts(salableData);
                }
            }
            }, 700);

            return () => clearTimeout(delayDebounceFn);
        }
        else {
            if (selectedCategory) {
            const productData = salableData.filter((product) => product.categoryId === selectedCategory);
            setShowProducts(sortProducts(productData));
            }
        }
        }, [searchInput, selectedCategory, salableData]);



    const scanBarcode = (e) => {
        if (e.key === "Enter") {
            const barcode = e.target.value;

            //Scale
            if (parseInt(barcode.substring(0, 2), 10) === 99) {
                handleScale(barcode)
            }
            else {
                const productExists = salableData.find(product => product.barcode == barcode);
                if (productExists) {
                    addProduct(productExists, 1)
                }
            }
            e.target.value = '';
        }
    };


    const handleScale = (barCodeSearch) => {

        // 2+4+6+5+1
        const barcode = barCodeSearch.substring(2, 6);
        const price = barCodeSearch.substring(6, 12);
        const weight = parseFloat(barCodeSearch.substring(12, 17)) / 1000;

        const digitCheckSum = barCodeSearch.substring(17, 18);
        const productExists = salableData.find(product => product.barcode == barcode);

        if (productExists) {
            productExists.netQuantity = weight;
            addProduct(productExists, weight);
        }

    };


    const items = useMemo(() =>
        [
            settingData.simpleProduct && {
                label: 'Simple',
                key: '1',
                onClick: () => openAddProductModal('simple')
            },
            settingData.serializedProduct && {
                label: 'Serialized',
                key: '2',
                onClick: () => openAddProductModal('serialized')
            },
        ]);

    return (
        <div style={{ width: '40%', margin: 0 }}>

            <div className="card" style={{ height: '7vh' }}>

                <Row>
                    <Col md={5}>
                        <InputGroup style={{ backgroundColor: '#f0f8ff' }}>
                            <Form.Control type="text" placeholder='scan barcode..'
                                onKeyDown={e => scanBarcode(e)}
                            />
                            <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col md={5}>
                        <InputGroup style={{ backgroundColor: '#f0f8ff' }}>
                            <Form.Control type="text" placeholder='search products..'
                                onChange={e => setSearchInput(e.target.value)}
                            />
                            <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col md={1}>
                        <FcRefresh onClick={refItems} style={{ cursor: 'pointer' }} size={35} />
                    </Col>
                    <Col md={1}>
                        <Dropdown menu={{ items }} trigger={['click']} overlayStyle={{ zIndex: 9999 }} transitionName="">
                            <a onClick={e => e.preventDefault()}>
                                <Space> <FaPlus style={{ marginLeft: '-15px', cursor: 'pointer' }} size={32} /> </Space>
                            </a>
                        </Dropdown>
                    </Col>
                </Row>

            </div>


            <div
                className="card custom-scrollbar"
                style={{
                    height: '93vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gridAutoRows: settingData?.showCostInBox ? '100px' : '80px',
                    gap: '5px',
                }}
            >
                {showProducts?.map((product, index) => (
                    <div
                        className="card"
                        key={index}
                        onClick={() => addProduct(product, 1)}
                        style={{
                            height: settingData?.showCostInBox ? '100px' : '80px',
                            width: '95%',
                            marginTop: 5,
                            padding: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#b7e3f2',
                            cursor: 'pointer',
                            fontWeight: '500',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                        }}
                        title={product?.name}
                    >
                        <div
                            style={{
                                display: '-webkit-box',
                                WebkitLineClamp: settingData?.showCostInBox ? 1 : 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'normal',
                                lineHeight: '1.2em',
                                maxHeight: settingData?.showCostInBox ? '1.2em' : '2.4em',
                                width: '100%',
                                textAlign: 'center',
                            }}
                        >
                            {product?.name}
                        </div>

                        {settingData?.showCostInBox && (
                            <div
                                style={{
                                    fontSize: '0.85em',
                                    color: 'red',
                                    marginTop: '3px',
                                    textAlign: 'center',
                                    width: '100%',
                                    height: '18px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {product?.cost ? `${numberFormatter(product?.cost)}${product.currency?.symbol}` : ''}
                            </div>
                        )}

                        {settingData?.showPriceInBox && (
                            <div
                                style={{
                                    fontSize: '0.9em',
                                    marginTop: '4px',
                                    textAlign: 'center',
                                    width: '100%',
                                    height: '20px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'green',
                                }}
                            >
                                {numberFormatter(product?.price)}{product.currency?.symbol}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {showMultiPriceModal &&
                <MultiPriceModal
                    showModal={showMultiPriceModal}
                    toggleModal={multiPriceModal}
                    idRow={idRow}
                    title={'Select Price'}
                    selectedTab={selectedTab}
                    selectedProduct={selectedProduct}
                    addProductToCart={addProductToCart}
                />
            }

            {showSerialModal &&
                <SerialModal
                    showModal={showSerialModal}
                    toggleModal={serialModal}
                    setSerial={setSerial}
                    serial={serial}
                    selectedProduct={selectedProduct}
                    addProductToCart={addProductToCart}
                />
            }

        </div>



    )
}


export default Product;